export enum AccountFlagEnum {
  None = 0,
  Demo = 1,
}

export const ACCOUNT_FLAG_LABELS: Record<AccountFlagEnum, string> = {
  [AccountFlagEnum.None]: 'None',
  [AccountFlagEnum.Demo]: 'Demo',
};

export function isHiddenFromRepSearch(accountFlagId?: AccountFlagEnum): boolean {
  return accountFlagId === AccountFlagEnum.Demo;
}

export function getAccountFlagLabel(accountFlagId?: AccountFlagEnum): string | null {
  if (accountFlagId === undefined || accountFlagId === AccountFlagEnum.None) {
    return null;
  }

  return ACCOUNT_FLAG_LABELS[accountFlagId];
}
